import NewPassword from './newPassword';
export default NewPassword;